import { ArrowRight, Layers3, ShieldCheck, Workflow } from 'lucide-react'
import { InteractiveSystemMap } from '../components/InteractiveSystemMap'
import { NeedsNavigator } from '../components/NeedsNavigator'
import { PageHero } from '../components/PageHero'
import { PageMeta } from '../components/PageMeta'
import { solutions } from '../content/site'

export function HomePage() {
  return (
    <main id="main-content" className="route-page">
      <PageMeta
        title="Business technology, made clear"
        description="Informat designs, builds and improves business technology across cloud platforms, devices, networks, websites, business systems and complex Microsoft environments."
      />
      <PageHero
        className="home-hero"
        title={
          <>
            Business technology,
            <br />
            made clear.<span className="text-cursor" aria-hidden="true" />
          </>
        }
        body="We design, build and improve the systems your business relies on—from email, files and devices to cloud platforms, networks, websites and complex Microsoft environments."
        primary={{ href: '/solutions', label: 'Explore solutions' }}
        secondary={{ href: '/contact', label: 'Discuss a project' }}
        visual={<InteractiveSystemMap />}
      />
      <NeedsNavigator />
      <section className="home-solutions section-dark" aria-labelledby="home-solutions-title">
        <div className="home-solutions__intro" data-reveal>
          <h2 id="home-solutions-title">More than one piece of technology.</h2>
          <p>
            Business technology works best when accounts, devices, communication, applications,
            networks, data and ownership are considered together.
          </p>
        </div>
        <div className="home-solutions__rows">
          {solutions.slice(0, 6).map((solution, index) => {
            const Icon = solution.icon
            return (
              <a href={`/solutions#${solution.id}`} key={solution.id} data-reveal>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <Icon aria-hidden="true" strokeWidth={1.2} />
                <strong>{solution.title}</strong>
                <p>{solution.summary}</p>
                <ArrowRight aria-hidden="true" strokeWidth={1.2} />
              </a>
            )
          })}
        </div>
        <a className="section-text-link" href="/solutions">
          View every solution <ArrowRight aria-hidden="true" />
        </a>
      </section>
      <section className="home-contexts section-light" aria-labelledby="contexts-title">
        <div data-reveal>
          <h2 id="contexts-title">Cloud. On-premises. Hybrid.</h2>
          <p>
            Informat works across the environment rather than forcing every business into the same
            platform or delivery model.
          </p>
        </div>
        <div className="context-rail">
          <article data-reveal>
            <Layers3 aria-hidden="true" strokeWidth={1.2} />
            <h3>Connected thinking</h3>
            <p>Technology decisions shaped around the business, its people and what already exists.</p>
          </article>
          <article data-reveal>
            <Workflow aria-hidden="true" strokeWidth={1.2} />
            <h3>Flexible engagement</h3>
            <p>The depth of work depends on the product, the project and the outcome required.</p>
          </article>
          <article data-reveal>
            <ShieldCheck aria-hidden="true" strokeWidth={1.2} />
            <h3>Clear ownership</h3>
            <p>Implementation, documentation and handover designed to leave responsibilities clear.</p>
          </article>
        </div>
      </section>
      <section className="closing-cta section-dark">
        <div data-reveal>
          <h2>Start with what needs to work better.</h2>
          <p>We can identify the right route from there.</p>
        </div>
        <a href="/contact">
          Discuss a project <ArrowRight aria-hidden="true" />
        </a>
      </section>
    </main>
  )
}
